import { IconAlertTriangle } from '@tabler/icons-react';
import { Grid } from '@mantine/core';
import React, { useEffect, useState } from 'react';

const FacebookAdFormPlacementError = ({ adPlacement }) => {
  const [errors, setErrors] = useState([]);

  useEffect(() => {
    validateAdPlacement(adPlacement);
  }, [adPlacement]);

  const validateAdPlacement = (adPlacement) => {
    const newErrors = [];

    if (adPlacement.device_platforms?.length < 1) {
      newErrors.push('You must select at least one DEVICE.');
    }

    if (adPlacement.publisher_platforms?.length < 1) {
      newErrors.push('You must select at least one PUBLISHER.');
    }

    if (adPlacement.publisher_platforms?.includes('audience_network')) {
      if (!adPlacement.publisher_platforms?.includes('facebook')) {
        newErrors.push('You must select the Facebook platform to use Audience Network.');
      }
    }

    if (!adPlacement.facebook_positions?.includes('feed')) {
      //Facebook
      if (adPlacement.facebook_positions?.includes('story')) {
        newErrors.push('To use the Facebook Stories placement, please also select either Facebook Feeds placement.');
      }

      if (adPlacement.facebook_positions?.includes('marketplace')) {
        newErrors.push(
          'To use the Facebook Marketplace placement, please also select either Facebook Feeds placement.'
        );
      }

      if (adPlacement.facebook_positions?.includes('instream_video')) {
        newErrors.push(
          'To use the Facebook In-Stream Video placement, please also select either Facebook Feeds placement.'
        );
      }

      if (adPlacement.facebook_positions?.includes('search')) {
        newErrors.push('To use the Facebook Search placement, please also select either Facebook Feeds placement.');
      }

      if (adPlacement.facebook_positions?.includes('facebook_reels')) {
        newErrors.push('To use the Facebook Reels placement, please also select either Facebook Feeds placement.');
      }
      //Messenger
      if (adPlacement.messenger_positions?.includes('story')) {
        newErrors.push('To use the Messenger Stories placement, please also select either Facebook Feeds placement.');
      }

      if (adPlacement.messenger_positions?.includes('messenger_home')) {
        newErrors.push('To use Messenger Home, please also select the Facebook Feeds placement.');
      }

      //Audience network
      if (
        adPlacement.audience_network_positions?.includes('classic') ||
        adPlacement.audience_network_positions?.includes('rewarded_video')
      ) {
        newErrors.push('You must select the Facebook feed placement to use Audience Network.');
      }
    }

    setErrors(newErrors);
  };

  const errorsElements = errors.map((err, index) => {
    return (
      <span key={index} style={{ color: 'var(--mantine-color-red-6)' }}>
        <IconAlertTriangle size={14} /> {err}
      </span>
    );
  });

  return (
    <Grid>
      <Grid.Col span={12} style={{ textAlign: 'right' }}>
        {errorsElements}
      </Grid.Col>
    </Grid>
  );
};

export default FacebookAdFormPlacementError;
